import {
  //celebration animtions
  Nuala1Celebrating,
  Nuala2Celebrating,
  Nuala3Celebrating,
  Nuala4Celebrating,
  Nuala5Celebrating,
  Nuala6Celebrating,
  Nuala7Celebrating,
  Nuala8Celebrating,
  Nuala9Celebrating,
  Nuala10Celebrating,
  Nuala11Celebrating,
  Nuala12Celebrating,
  Nuala13Celebrating,
  Nuala14Celebrating,
  Nuala15Celebrating,
  Nuala16Celebrating,
  Nuala17Celebrating,
  Nuala18Celebrating,
  Nuala19Celebrating,
  Nuala20Celebrating,
  Nuala21Celebrating,

  //speaking animations
  Nuala1Speaking,
  Nuala2Speaking,
  Nuala3Speaking,
  Nuala4Speaking,
  Nuala5Speaking,
  Nuala6Speaking,
  Nuala7Speaking,
  Nuala8Speaking,
  Nuala9Speaking,
  Nuala10Speaking,
  Nuala11Speaking,
  Nuala12Speaking,
  Nuala13Speaking,
  Nuala14Speaking,
  Nuala15Speaking,
  Nuala16Speaking,
  Nuala17Speaking,
  Nuala18Speaking,
  Nuala19Speaking,
  Nuala20Speaking,
  Nuala21Speaking,

} from "./animations";


import Nuala1Image from "./img/avatars/0-nuala-001.svg";

import Nuala2Image from "./img/avatars/0-nuala-002.svg";

import Nuala3Image from "./img/avatars/0-nuala-003.svg";

import Nuala4Image from "./img/avatars/0-nuala-004.svg";

import Nuala5Image from "./img/avatars/0-nuala-005.svg";

import Nuala6Image from "./img/avatars/0-nuala-006.svg";

import Nuala7Image from "./img/avatars/0-nuala-007.svg";

import Nuala8Image from "./img/avatars/0-nuala-008.svg";

import Nuala9Image from "./img/avatars/0-nuala-009.svg";

import Nuala10Image from "./img/avatars/0-nuala-010.svg";

import Nuala11Image from "./img/avatars/0-nuala-011.svg";

import Nuala12Image from "./img/avatars/0-nuala-012.svg";

import Nuala13Image from "./img/avatars/0-nuala-013.svg";

import Nuala14Image from "./img/avatars/0-nuala-014.svg";

import Nuala15Image from "./img/avatars/0-nuala-015.svg";

import Nuala16Image from "./img/avatars/0-nuala-016.svg";

import Nuala17Image from "./img/avatars/0-nuala-017.svg";

import Nuala18Image from "./img/avatars/0-nuala-018.svg";

import Nuala19Image from "./img/avatars/0-nuala-019.svg";

import Nuala20Image from "./img/avatars/0-nuala-020.svg";

import Nuala21Image from "./img/avatars/0-nuala-021.svg";

export default {
  nuala1: {
    userImage: Nuala1Image,
    speakingImage: Nuala1Speaking,
    celebratingImage: Nuala1Celebrating,
  },
  nuala2: {
    userImage: Nuala2Image,
    speakingImage: Nuala2Speaking,
    celebratingImage: Nuala2Celebrating,
  },
  nuala3: {
    userImage: Nuala3Image,
    speakingImage: Nuala3Speaking,
    celebratingImage: Nuala3Celebrating,
  },
  nuala4: {
    userImage: Nuala4Image,
    speakingImage: Nuala4Speaking,
    celebratingImage: Nuala4Celebrating,
  },
  nuala5: {
    userImage: Nuala5Image,
    speakingImage: Nuala5Speaking,
    celebratingImage: Nuala5Celebrating,
  },
  nuala6: {
    userImage: Nuala6Image,
    speakingImage: Nuala6Speaking,
    celebratingImage: Nuala6Celebrating,
  },
  nuala7: {
    userImage: Nuala7Image,
    speakingImage: Nuala7Speaking,
    celebratingImage: Nuala7Celebrating,
  },
  nuala8: {
    userImage: Nuala8Image,
    speakingImage: Nuala8Speaking,
    celebratingImage: Nuala8Celebrating,
  },
  nuala9: {
    userImage: Nuala9Image,
    speakingImage: Nuala9Speaking,
    celebratingImage: Nuala9Celebrating,
  },
  nuala10: {
    userImage: Nuala10Image,
    speakingImage: Nuala10Speaking,
    celebratingImage: Nuala10Celebrating,
  },
  nuala11: {
    userImage: Nuala11Image,
    speakingImage: Nuala11Speaking,
    celebratingImage: Nuala11Celebrating,
  },
  nuala12: {
    userImage: Nuala12Image,
    speakingImage: Nuala12Speaking,
    celebratingImage: Nuala12Celebrating,
  },
  nuala13: {
    userImage: Nuala13Image,
    speakingImage: Nuala13Speaking,
    celebratingImage: Nuala13Celebrating,
  },
  nuala14: {
    userImage: Nuala14Image,
    speakingImage: Nuala14Speaking,
    celebratingImage: Nuala14Celebrating,
  },
  nuala15: {
    userImage: Nuala15Image,
    speakingImage: Nuala15Speaking,
    celebratingImage: Nuala15Celebrating,
  },
  nuala16: {
    userImage: Nuala16Image,
    speakingImage: Nuala16Speaking,
    celebratingImage: Nuala16Celebrating,
  },
  nuala17: {
    userImage: Nuala17Image,
    speakingImage: Nuala17Speaking,
    celebratingImage: Nuala17Celebrating,
  },
  nuala18: {
    userImage: Nuala18Image,
    speakingImage: Nuala18Speaking,
    celebratingImage: Nuala18Celebrating,
  },
  nuala19: {
    userImage: Nuala19Image,
    speakingImage: Nuala19Speaking,
    celebratingImage: Nuala19Celebrating,
  },
  nuala20: {
    userImage: Nuala20Image,
    speakingImage: Nuala20Speaking,
    celebratingImage: Nuala20Celebrating,
  },
  nuala21: {
    userImage: Nuala21Image,
    speakingImage: Nuala21Speaking,
    celebratingImage: Nuala21Celebrating,
  },
};

